class GoogleMarkerController {
    constructor($scope) {
        this.marker = this.markerOptions instanceof google.maps.Marker
            ? this.markerOptions
            : new google.maps.Marker(this.markerOptions);

        if (this.onClick) {
            this.marker.addListener('click', () => $scope.$apply(() => this.onClick({ marker: this.marker })));
        }

        $scope.$on('$destroy', () => this.setMap(null));
    }

    setMap(map) {
        this.map = map;
        this.marker.setMap(map);
    }
}

const googleMarkerDirectiveDefinition = () => ({
    restrict: 'E',
    require: ['olyGoogleMapMarker', '^olyGoogleMap'],
    scope: {},
    bindToController: {
        marker: '=?',
        markerOptions: '=',
        onClick: '&?',
    },
    controller: ['$scope', GoogleMarkerController],
    controllerAs: 'googleMarkerCtrl',
    link(scope, element, attrs, controllers) {
        const markerCtrl = controllers[0];
        const mapCtrl = controllers[1];

        markerCtrl.setMap(mapCtrl.getMap());
    },
    template: '',
});

module.exports = {
    GoogleMarkerController,
    googleMarkerDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-marker.directive.js